import { render } from "./TextImage.vue?vue&type=template&id=beb1440e"
import script from "./TextImage.vue?vue&type=script&lang=js"
export * from "./TextImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__